import { render, staticRenderFns } from "./CaroselloViewer.vue?vue&type=template&id=559ffc9c&scoped=true"
import script from "./CaroselloViewer.vue?vue&type=script&lang=js"
export * from "./CaroselloViewer.vue?vue&type=script&lang=js"
import style0 from "./CaroselloViewer.vue?vue&type=style&index=0&id=559ffc9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559ffc9c",
  null
  
)

export default component.exports